import { gql } from "@apollo/client";

export const PERSON_TICKET_HISTORY = gql`
  query personTicketHistory($personId: ID!, $originatorId: ID!) {
    personTicketHistory(personId: $personId, originatorId: $originatorId) {
      id
      ticketNumber
      issuedAt
      incident {
        id
        incidentNumber
        sealed
        locked
        address {
          name
        }
      }
      officer {
        id
        deptAttribute {
          badge
        }
        personalAttribute {
          firstName
          lastName
        }
      }
      ticketLocation {
        name
      }
      ticketViolationPrototype {
        code
        name
        ticketEntry {
          name
        }
      }
    }
  }
`;
